import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/ServiceStore";
// actions
import ContactUsServiceAction from "@/cms/actions/services/ContactUsServiceAction";
// types
import TBase from "@/cms/types/TBase";
import TBaseReduxStoreState from "@/core/types/TBaseReduxStoreState";
// enums
import EContactUsStatus from "@/cms/enums/EContactUsStatus";
import TValidations from "@/cms/types/TValidations";


type TUseContentIn = {
    unqKey:string;
}

type TUseSearchOut = {
    _post: ( payload:any ) => void;
    _remove: () => void;
} & TBaseReduxStoreState<TBase|null,TValidations[]|null>;

const useContactUs = ( props:TUseContentIn ):TUseSearchOut => {
    const dispatch = useDispatch();

    const unqKey = `${props.unqKey}CU`;

    const contactUsServiceAction = new ContactUsServiceAction(dispatch, unqKey);
    AppStore.reducerManager.add(unqKey, Store(unqKey, contactUsServiceAction.serviceCode));
    
    const payload = useSelector((state:any) => state?.[unqKey]?.post, shallowEqual);
    const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.language?.payload?.code, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(unqKey); } }, []);

    const _post = ( payload:any ) => {
        contactUsServiceAction.post({ servicePayload: { body: { ...payload, status: EContactUsStatus.NEW }, language: webApplicationLanguageCode } })
    }

    const _remove = () => {
        contactUsServiceAction.postClean();
    }

    return {
        ...payload,
        _post,
        _remove,
    }
}

export default useContactUs;
